import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {CustomerRequestStatusEnum} from "../../core_modules/enums/customer-request-status.enum";
import {AdminMenuCodeEnum} from "../../core_modules/enums/admin-menu-code.enum";

@Injectable({
  providedIn: 'root',
})
export class MenuStorageService {

  private _menuList: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public readonly menuList$ = this._menuList.asObservable();

  // store permission codes
  public allowedMenuCodes = new Set<AdminMenuCodeEnum>();

  // optional if you still need route guards
  public allowedRoutes = new Set<string>();

  public updateMenuList(menuList: any[]) {
    this.setPermissions(menuList);
    this._menuList.next(this.filterMenu(menuList));
  }

  private setPermissions(menuList: any[]) {

    this.allowedMenuCodes.clear();
    this.allowedRoutes.clear();

    const extract = (menus: any[]) => {

      menus.forEach(menu => {

        if (menu?.code) {
          this.allowedMenuCodes.add(menu.code);
        }

        if (menu?.link) {
          this.allowedRoutes.add(menu.link);
        }

        if (menu?.children?.length > 0) {
          extract(menu.children);
        }

      });
    };

    extract(menuList);
  }

  public canUserAccess(code: AdminMenuCodeEnum): boolean {
    return this.allowedMenuCodes.has(code);
  }

  public canAccessRoute(route: string): boolean {
    return this.allowedRoutes.has(route);
  }

  private filterMenu(menu: any[]): any[] {
    return menu
      .filter(item => item.isMenu === 'Y')
      .map(item => ({
        ...item,
        children: item.children
          ? this.filterMenu(item.children)
          : undefined,
      }));
  }

  public clearMenu(): void {
    this.allowedMenuCodes.clear();
    this.allowedRoutes.clear();
    this._menuList.next(null);
  }
}
